export default __webpack_public_path__ + "static/media/mmg_logo.aa8b6685.jpg";